import './Footer.css';
import logo from './company-logo.png';
const LINKS = {
  Platform: ['Admin Portal', 'Candidate Portal', 'Assessment Engine', 'Analytics Dashboard', 'Recruiter Tools', 'Job Management'],
  Features: ['AI Test Builder', 'Resume Library', 'Interview Scheduling', 'Candidate Tracking', 'Role-Based Access', 'Audit Logs'],
  Company: ['About Aiprus', 'Blog', 'Case Studies', 'Documentation', 'Privacy Policy', 'Terms of Service'],
};

const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });

export default function Footer({ setActiveSection }) {
  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="footer__brand">
          {/* Logo */}
          <div className="footer__logo">
            <div className="footer__v-mark">
              <img
                src={logo}
                alt="Verdict Logo"
                className="footer__logo-img"
              />
            </div>
            <div>
              <div className="footer__name">VERDICT</div>
              <div className="footer__sub">by Aiprus Software</div>
            </div>
          </div>

          {/* Acronym small */}
          <div className="footer__acronym">
            {[
              ['V', 'alidated'], ['E', 'valuation'], ['R', 'ecruitment'],
              ['D', 'ecisions'], ['I', 'ntelligent'], ['C', 'ompetency'], ['T', 'racking'],
            ].map(([l, r]) => (
              <div key={l} className="footer-acro-line">
                <span className="footer-acro-l">{l}</span>
                <span className="footer-acro-r">{r}</span>
              </div>
            ))}
          </div>

          <p className="footer__desc">
            Aiprus Software's AI-powered hiring platform — replacing your ATS,
            assessment tool, and analytics sheet with one intelligent system.
          </p>

          <div className="footer__contacts">
            <a href="mailto:support@aiprus.com" className="footer__contact-link">📧 support@aiprus.com</a>
            <a href="tel:+918420006452" className="footer__contact-link">📞 +91-842-000-6452</a>
            <a href="https://www.aiprus.com" target="_blank" rel="noreferrer" className="footer__contact-link">🌐 www.aiprus.com</a>
          </div>
        </div>

        {/* Link columns */}
        {Object.entries(LINKS).map(([col, items]) => (
          <div key={col} className="footer__col">
            <p className="footer__col-title">{col}</p>
            {items.map(item => (
              <button
                key={item}
                className="footer__link"
                onClick={() => {
                  const map = {
                    'Admin Portal': '#admin', 'Candidate Portal': '#candidate',
                    'Assessment Engine': '#features', 'Analytics Dashboard': '#features',
                    'Recruiter Tools': '#admin', 'Job Management': '#admin',
                  };
                  scrollTo(map[item] || '#what');
                }}
              >
                {item}
              </button>
            ))}
          </div>
        ))}
      </div>

      {/* CTA bar */}
      <div className="footer__cta-bar">
        <div className="footer__cta-text">
          <span>Ready to deliver your best hiring VERDICT?</span>
          <span className="footer__cta-sub"> · Free trial · No credit card required</span>
        </div>
        <button className="btn-purple" style={{ padding: '.55rem 1.4rem', fontSize: '.88rem', borderRadius: '8px' }}
          onClick={() => scrollTo('#contact')}>
          Get Started Free
        </button>
      </div>

      {/* Bottom bar */}
      <div className="footer__bottom">
        <span>© 2025 Aiprus Software Pvt Ltd. All rights reserved.</span>
        <div className="footer__legal">
          {['Privacy Policy', 'Terms of Service', 'Cookie Policy'].map(l => (
            <button key={l} className="footer__legal-link" onClick={() => scrollTo('#contact')}>{l}</button>
          ))}
        </div>
      </div>
    </footer>
  );
}
